import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { PasslyButton } from '@app/components';
import { SetLoginForm } from '@app/models';
import { loginForms } from '@app/enums';
import { handleGoToSignIn } from "@app/modules/mfaToken/helpers";
import { useDispatch } from "react-redux";

interface IProps {
    setLoginForm: SetLoginForm;
}

export function SelectAnotherProvider({ setLoginForm }: IProps) {
    const { translation } = useTypedTranslation();
    const dispatch = useDispatch();

    return (
      <div className='twofactorauth__footer'>
        <PasslyButton
          className='twofactorauth__button'
          id='selectAnother'
          color='primary'
          onClick={handleGoToSignIn(dispatch, setLoginForm)}
          disableRipple={true}
        >
          {translation('SIGNIN_OPTIONS_OTHER')}
        </PasslyButton>
      </div>
    );
}
